import React, { useState } from 'react';
import SendOtpForm from './SendOtpForm';
import ResetPasswordForm from './ResetPasswordForm';

interface ForgotPasswordFormProps {
  onBackToLogin: () => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [otpSent, setOtpSent] = useState(false);

  const handleOtpSent = (userEmail: string) => {
    setEmail(userEmail);
    setOtpSent(true);
  };

  const handlePasswordReset = () => {
    onBackToLogin();
  };

  return (
    <>
      {!otpSent ? (
        <SendOtpForm
          onOtpSent={handleOtpSent}
          onBackToLogin={onBackToLogin}
        />
      ) : (
        <ResetPasswordForm
          email={email}
          onPasswordReset={handlePasswordReset}
          onBackToLogin={onBackToLogin}
        />
      )}
    </>
  );
};

export default ForgotPasswordForm; 